import { atom } from "recoil";

import { OfficerMe } from "graphql/type";

export type User = OfficerMe | null;

export const userStore = atom<User>({
  key: "user",
  default: null,
});
